import { PageTitle } from '_metronic/layout/core'

import { Tooltip } from 'react-tooltip'
import FormGenerator from 'Presentation/Components/Form/FormGenerator'
import TabsButtonGroup from 'Presentation/Components/Tabs/ButtonGroup'
import Editor from 'Presentation/Components/Editor'
import Select from 'react-select'
import BusinessLocationSelection from '../BusinessLocationSelection/View'
import LogoInput from 'Presentation/Components/LogoInput'
import {
	QUILL_FORMATS_EXTREME_MINIMAL_CONFIG,
	QUILL_MODULES_EXTREME_MININMAL_CONFIG,
} from 'Configuration/Quill'
import { TABS } from '../Config'

import useViewModel from './ViewModel'
import { isMobileDevice } from '_metronic/assets/ts/_utils'
import clsx from 'clsx'
import { generateImageUrl } from 'Utils/generateImageUrl'
import KumopackVariables from 'Styles/Variables/_metronic-variables.scss'

//////////
// View //
//////////

const ProfileAccountInfoView: React.FC = () => {
	const {
		companyName,
		currentTab,
		onChangeTab,
		formState,
		onChange,
		onSubmit,
		handleOpenSelectLocation,
		isSubmitting,
		error,
		isBusinessDescriptionOver,
		deliveryDateAmountOptions,
	} = useViewModel()
	const isHorizontal = !isMobileDevice()

	return (
		<ViewPageTitle companyName={companyName}>
			<BusinessLocationSelection />

			<div className="row gy-5">
				<div className="col-12 d-none d-xl-block">
					<TabsButtonGroup
						manualActiveTab={currentTab}
						changeTab={onChangeTab}
						tabNames={TABS.map(tab => tab.tabName)}
						tabContents={[<></>]}
					/>
				</div>

				<div className="col-12 d-xl-none">
					<Select
						isSearchable={false}
						options={TABS.map((tab, idx) => ({ value: idx, label: tab.tabName }))}
						value={{ label: TABS.find((_, idx) => idx === currentTab)?.tabName }}
						styles={{
							control: (baseStyles, state) => ({
								...baseStyles,
								border: '1px solid #e1e3ea',
							}),
							menu: (baseStyles, state) => ({
								...baseStyles,
								zIndex: 9999,
							}),
						}}
						onChange={(selected: any) => {
							if (selected !== null) onChangeTab(Number(selected?.value))
						}}
					/>
				</div>

				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-header border-0 mt-4">
							<div className="card-title">
								{/* Title */}
								<div>
									<h4 className="text-kumopack-grey-900 fw-bold mb-2">โปรไฟล์โรงงาน</h4>
									<div className="text-kumopack-grey-600 fs-6">
										Please specify page description here
									</div>
								</div>
							</div>
							<div className="mt-2 separator border-1px w-100 border-kumopack-grey-200"></div>
						</div>

						<div className="card-body">
							<LogoInput
								wording="โลโก้โรงงาน"
								// @ts-ignore
								image={formState.companyLogo}
								changeImage={img => onChange('companyLogo', img)}
							/>

							<FormGenerator
								disabled
								formKey="code"
								inputType="plain"
								label="รหัสร้านค้า"
								containerClassName="mb-5"
								isHorizontal={isHorizontal}
								tooltip="รหัสนี้ถูกสร้างจากระบบโดยอัติโนมัติ ไม่สามารถแก้ไขได้"
								value={formState.code}
								onChange={e => onChange('code', e.target.value)}
							/>

							<FormGenerator
								formKey="slug"
								disabled={isSubmitting}
								inputType={isMobileDevice() ? 'plain' : 'prefix'}
								label="ชื่อเรียก (URL Slug)"
								additionalLabelCom={<span className="required" />}
								placeholder="ชื่อเรียก (URL Slug)"
								prefix="kumopack.com/supplier/detail/"
								containerClassName="my-5"
								isHorizontal={!isMobileDevice()}
								value={formState.slug}
								onChange={e => onChange('slug', e.target.value)}
								tooltip='ชื่อเรียก (URL Slug) จะถูกใช้เป็น URL ของหน้าโปรไฟล์ของคุณ เช่น "kumopack.com/suppliers/ชื่อเรียก"'
								isShowValid={!!error?.slug}
								additionalComInput={
									error?.slug ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.slug}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="displayTitle"
								disabled={isSubmitting}
								inputType="plain"
								label="ชื่อที่ปรากฎให้เห็น / ชื่อร้านค้า"
								additionalLabelCom={<span className="required" />}
								placeholder="ชื่อที่ปรากฎให้เห็น / ชื่อร้านค้า"
								containerClassName="mb-5"
								isHorizontal={!isMobileDevice()}
								value={formState.displayTitle}
								onChange={e => onChange('displayTitle', e.target.value)}
								isShowValid={!!error?.displayTitle}
								additionalComInput={
									error?.displayTitle ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.displayTitle}</div>
										</div>
									) : undefined
								}
							/>

							{/* <FormGenerator
								formKey="companyName"
								inputType="plain"
								label="ชื่อบริษัท / ชื่อเจ้าของกิจการ"
								additionalLabelCom={<span className="required" />}
								placeholder="ชื่อบริษัท / ชื่อเจ้าของบริษัท"
								containerClassName="mb-5"
								isHorizontal={!isMobileDevice()}
								value={formState.companyName}
								onChange={e => onChange('companyName', e.target.value)}
							/> */}

							<FormGenerator
								formKey="contactPersonFullname"
								disabled={isSubmitting}
								inputType="plain"
								label="ชื่อผู้ติดต่อ"
								additionalLabelCom={<span className="required" />}
								placeholder="ชื่อผู้ติดต่อ"
								containerClassName="mb-5"
								isHorizontal={!isMobileDevice()}
								value={formState.contactPersonFullname}
								onChange={e => onChange('contactPersonFullname', e.target.value)}
								isShowValid={!!error?.contactPersonFullname}
								additionalComInput={
									error?.contactPersonFullname ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.contactPersonFullname}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="contactPersonPosition"
								disabled={isSubmitting}
								inputType="plain"
								label="ตำแหน่งของผู้ติดต่อ"
								additionalLabelCom={<span className="required" />}
								placeholder="ตำแหน่งของผู้ติดต่อ"
								containerClassName="mb-5"
								isHorizontal={!isMobileDevice()}
								value={formState.contactPersonPosition}
								onChange={e => onChange('contactPersonPosition', e.target.value)}
								tooltip='เช่น "ผู้บริหาร, พนักงานขาย, ผู้จัดการ"'
								isShowValid={!!error?.contactPersonPosition}
								additionalComInput={
									error?.contactPersonPosition ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.contactPersonPosition}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="contactPersonEmail"
								disabled={isSubmitting}
								inputType={'plain'}
								label="อีเมลของผู้ติดต่อ"
								additionalLabelCom={<span className="required" />}
								containerClassName="mb-5"
								isHorizontal={!isMobileDevice()}
								value={formState.email}
								onChange={e => onChange('email', e.target.value)}
								isShowValid={!!error?.email}
								additionalComInput={
									error?.email ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{error.email}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="website"
								disabled={isSubmitting}
								inputType={'plain'}
								label="Website"
								containerClassName="mb-5"
								isHorizontal={!isMobileDevice()}
								value={formState.website}
								onChange={e => onChange('website', e.target.value)}
								isShowValid={!!error?.website}
								additionalComInput={
									<>
										<div className="text-kumopack-grey-500 mt-2">
											กรุณากรอก full url e.g. https://kumopack.com หรือ https://www.kumopack.com
										</div>

										{error?.website ? (
											<div className="fv-plugins-message-container mt-2">
												<div className="fv-help-block">{error.website}</div>
											</div>
										) : undefined}
									</>
								}
							/>

							<FormGenerator
								formKey="latitude"
								value={formState.latitude}
								inputType="plain"
								label="ละติจูด"
								additionalLabelCom={<span className="required" />}
								placeholder="13.7563"
								containerClassName="mb-5"
								isHorizontal={!isMobileDevice()}
								disabled
							/>

							<FormGenerator
								formKey="longitude"
								value={formState.longitude}
								inputType="plain"
								label="ลองจิจูด"
								additionalLabelCom={<span className="required" />}
								additionalComInput={
									<button
										className="mt-5 btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white"
										onClick={handleOpenSelectLocation}>
										คลิกเพื่อเลือกจากแผนที่
									</button>
								}
								placeholder="100.5018"
								containerClassName="mb-5"
								isHorizontal={!isMobileDevice()}
								disabled
							/>

							<FormGenerator
								formKey="tagline"
								inputType="textarea"
								containerClassName="mb-5"
								isHorizontal={!isMobileDevice()}
								label="Tagline"
								disabled={isSubmitting}
								value={formState.tagline}
								onChange={e => onChange('tagline', e.target.value)}
								limitCharacter={80}
							/>

							<FormGenerator
								formKey="cardDescription"
								inputType="textarea"
								containerClassName="mb-5"
								isHorizontal={!isMobileDevice()}
								label="Card Description"
								disabled={isSubmitting}
								value={formState.cardDescription}
								onChange={e => onChange('cardDescription', e.target.value)}
								limitCharacter={80}
							/>

							<div className={`mb-5 d-flex flex-column flex-xl-row`}>
								<label
									className={`form-label col-12 col-xl-3 mb-0 mb-5 mb-xl-0`}
									data-testid="form-input-label-component">
									<div className="d-flex flex-column">
										<span>ระยะเวลาจัดส่ง</span>
									</div>
								</label>

								<div className="col-12 col-xl-9">
									<Select
										placeholder=""
										options={deliveryDateAmountOptions}
										value={
											deliveryDateAmountOptions.find(
												o => o.value === formState.deliveryDateAmount
											) ?? null
										}
										onChange={(selected: any) => {
											onChange('deliveryDateAmount', selected.value)
										}}
										styles={{
											control: (baseStyles, state) => ({
												...baseStyles,
												borderColor: state.isFocused
													? KumopackVariables['kumopack-primary-700']
													: baseStyles.borderColor,
												boxShadow: 'none',
												'&:hover': {
													borderColor: KumopackVariables['kumopack-primary-700'],
												},
												'&:focus': {
													borderColor: KumopackVariables['kumopack-primary-700'],
												},
												'&:active': {
													borderColor: KumopackVariables['kumopack-primary-700'],
												},
											}),
											option: (baseStyles, state) => ({
												...baseStyles,
												backgroundColor: state.isSelected
													? KumopackVariables['kumopack-primary-700']
													: baseStyles.backgroundColor,
												'&:hover': {
													backgroundColor: KumopackVariables['kumopack-primary-700'],
													color: KumopackVariables['kumopack-base-white'],
												},
												'&:focus': {
													backgroundColor: KumopackVariables['kumopack-primary-700'],
													color: KumopackVariables['kumopack-base-white'],
												},
												'&:active': {
													borderColor: KumopackVariables['kumopack-primary-700'],
												},
											}),
										}}
									/>
								</div>
							</div>

							<div className={`mb-5 d-flex flex-column flex-xl-row`}>
								<label
									className={`form-label col-12 col-xl-3 mb-0 mb-5 mb-xl-0`}
									data-testid="form-input-label-component">
									<div className="d-flex flex-column">
										<span>Business Description</span>
									</div>
								</label>

								<div className="col-12 col-xl-9">
									<Editor
										modules={QUILL_MODULES_EXTREME_MININMAL_CONFIG}
										formats={QUILL_FORMATS_EXTREME_MINIMAL_CONFIG}
										value={formState.businessDescription}
										onChange={(value, _, source) => {
											if (source === 'user') onChange('businessDescription', value)
										}}
										limitCharacter={300}
										height={350}
									/>
								</div>
							</div>

							<div className="mb-5 d-flex flex-column flex-xl-row">
								<label
									className={`form-label col-12 col-xl-3 mb-0 mb-5 mb-xl-0`}
									data-testid="form-input-label-component">
									<div className="d-flex flex-column">
										<span>Features</span>
									</div>
								</label>

								<div className="row w-100">
									{formState.supplierFeatures.length === 0 && (
										<div className="text-kumopack-grey-500 fs-4 text-center py-10">
											ไม่มี Supplier Features ในขณะนี้
										</div>
									)}
									{formState.supplierFeatures.map((feature: any, idx) => {
										if (feature.supplierActive !== 1) return null

										return (
											<div
												className="mb-5 d-flex flex-column align-items-center feature-container"
												key={`supplier-feature-${idx}`}
												id={`supplier-feature-${feature?.taxonomy?.id}-${idx}`}>
												<img
													className="w-50px h-50px object-fit-cover rounded-circle mb-5 cursor-pointer"
													src={
														feature?.taxonomy?.featurePicturePath
															? generateImageUrl(feature?.taxonomy?.featurePicturePath)
															: '/media/icons/kumopack/default-placeholder.png'
													}
													onError={e => {
														e.currentTarget.src = '/media/icons/kumopack/default-placeholder.png'
													}}
													alt={feature?.taxonomy?.nameTh}
												/>

												<Tooltip anchorSelect={`#supplier-feature-${feature?.taxonomy?.id}-${idx}`}>
													{feature?.taxonomy?.nameTh}
												</Tooltip>
											</div>
										)
									})}
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-12 text-end">
					<button
						disabled={isSubmitting || isBusinessDescriptionOver}
						onClick={onSubmit}
						className={clsx(
							'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white fw-bold',
							{
								'w-200px': !isMobileDevice(),
								'w-sm-100': isMobileDevice(),
							}
						)}>
						บันทึก
					</button>
				</div>
			</div>

			<style>{`
				.feature-container {
					width: 10%;
				}
			`}</style>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode; companyName: string }> = ({
	children,
	companyName,
}) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'My Account',
						path: '/profile',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Account Information',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				{companyName}
			</PageTitle>

			{children}
		</>
	)
}

export default ProfileAccountInfoView
